import { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('Verifying your email...')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setMessage('Invalid or missing verification token.')
      return
    }

    fetch('/api/v1/auth/verify-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token })
    })
      .then(async (response) => {
        const data = await response.json()
        if (response.ok) {
          setStatus('success')
          setMessage(data.message || 'Email verified successfully. You can now sign in.')
        } else {
          setStatus('error')
          setMessage(data.error || 'Verification failed. The link may be invalid or expired.')
        }
      })
      .catch((error) => {
        console.error('Verification error:', error)
        setStatus('error')
        setMessage('Network error. Please try again or request a new verification link.')
      })
  }, [token])

  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', '--bg-primary': '#F7FAF7', '--forest-green': '#1B5E20', '--slate': '#4A5568', '--border': '#E2E8F0', '--text-primary': '#1A202C', '--text-secondary': '#4A5568', '--text-muted': '#A0AEC0', '--success-bg': '#C6F6D5', '--success-text': '#276749', '--success-border': '#9AE6B4', '--error-bg': '#FED7D7', '--error-text': '#C53030', '--error-border': '#FC8181', '--info-bg': '#EDF2F7'} as React.CSSProperties}>
      <header style={{
        background: '#fff',
        borderBottom: '1px solid var(--border)',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: '1rem 0'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 clamp(1rem, 4vw, 2rem)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Link to="/" style={{display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none'}}>
            <img src="/IGotThat_logo_bk.svg" alt="I Got That U.S." width={230} height={34} style={{width: '230px', height: 'auto', display: 'block'}} />
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8" style={{paddingTop: '0', paddingBottom: '80px', background: 'var(--bg-primary)', minHeight: 'calc(100vh - 72px)'}}>
        <div className="w-full max-w-md" style={{width: '100%', maxWidth: '480px', padding: '1rem'}}>
          <div className="bg-white rounded-2xl shadow-lg border border-[var(--border)]" style={{
            padding: 'clamp(1.5rem, 5vw, 2.5rem)',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h1 style={{fontSize: '2rem', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 0.5rem 0', letterSpacing: '-0.02em'}}>
              Email Verification
            </h1>

            <div style={{
              marginBottom: '1.5rem',
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              background: status === 'success' ? 'var(--success-bg)' : status === 'error' ? 'var(--error-bg)' : 'var(--info-bg)',
              color: status === 'success' ? 'var(--success-text)' : status === 'error' ? 'var(--error-text)' : 'var(--text-secondary)',
              fontSize: '0.875rem',
              border: `1px solid ${status === 'success' ? 'var(--success-border)' : status === 'error' ? 'var(--error-border)' : 'var(--border)'}`
            }}>
              {message}
            </div>

            {status === 'success' && (
              <Link
                to="/login"
                style={{
                  display: 'inline-block',
                  padding: '0.75rem 1.5rem',
                  background: 'var(--forest-green)',
                  color: 'white',
                  fontWeight: 600,
                  borderRadius: '8px',
                  textDecoration: 'none'
                }}
              >
                Sign In
              </Link>
            )}

            {status === 'error' && (
              <Link
                to="/login"
                style={{
                  display: 'inline-block',
                  padding: '0.75rem 1.5rem',
                  background: 'var(--slate)',
                  color: 'white',
                  fontWeight: 600,
                  borderRadius: '8px',
                  textDecoration: 'none'
                }}
              >
                Back to Sign In
              </Link>
            )}
          </div>
        </div>
      </main>
    </div>
  )
}

export default VerifyEmail
